<template>
  <div
    :class="$style.card"
    @click="openModal"
  >
    <div
      :class="$style.simulationContainer"
      :data-test-id="$testId(label)"
    >
      <img
        :class="$style.thumbnail"
        src="img/growth/home-resources-simulation-thumbnail.png"
      >
      <p :class="$style.label">
        {{ label }}
      </p>
    </div>
  </div>
</template>

<script>
import { eventProperties } from 'client/GrowthEngineering/utilities/GrowthConstants';
import CardMixin from 'client/components/FeaturedItemsCarousel/cards/CardMixin';
import ModalEventBus from 'components/Modal/ModalEventBus';
import SimulationModal from 'client/components/Modal/SimulationModal.vue';

const {
  description,
  section,
  text,
} = eventProperties;

export default {
  name: 'SimulationCard',

  mixins: [CardMixin],

  ModalEventBus,

  data() {
    return {
      label: this.card.label,
      url: this.card.url,
    };
  },

  methods: {
    handleSimulationClicked() {
      const event = {
        [description]: 'Open Tutorial Resources Simulation Modal',
        [section]: 'Tutorial Resources Widget',
        [text]: this.card.label,
      };

      this.$emit('simulation-clicked', event);
    },

    openModal() {
      this.handleSimulationClicked();

      this.$options.ModalEventBus.open({
        component: SimulationModal,
        isLargeModal: true,
        componentProps: {
          iframeSrc: this.card.iframeUrl,
          simulationUrl: this.card.url,
        },
      });
    },
  },
};
</script>

<style module>
.card {
  height: 100%;
}

.card:hover {
  cursor: pointer;
}

.simulationContainer {
  height: 100%;
}

.thumbnail {
  height: 80%;
  width: 27rem;
}

.label.label {
  color: var(--jcGrey800);
  font-size: 14px;
  font-weight: 300;
}
</style>
